<template>
  <main :class="$style.view" v-if="page.fields">
    <ul :class="$style.list">
      <li
        v-for="(item, index) in sortedWorks"
        :key="`item-${index}`"
        :class="$style.item"
      >
        <image-item
          v-if="item.image"
          :class="$style.image"
          tag="div"
          :image="item.image"
        />
        <div v-else-if="item.year" :class="$style.year" v-html="item.year" />
      </li>
    </ul>
  </main>
</template>

<script>
import PageService from '@/services/page'
import ImageItem from '@/components/image-item'

export default {
  components: {
    ImageItem
  },
  metaInfo() {
    return {
      title: this.page.fields ? this.page.fields.title : ''
    }
  },
  data() {
    return {
      page: {}
    }
  },
  computed: {
    sortedWorks() {
      let sorted = []

      this.page.chronology.forEach(image => {
        const year = image.incoming_year
        const yearExists = sorted.some(obj => obj.year === year)
        const yearObj = { year }
        const imgObj = { image }
        if (!yearExists) {
          sorted.push(yearObj, imgObj)
        } else {
          sorted.push(imgObj)
        }
      })
      return sorted
    }
  },
  async created() {
    this.page = await PageService.get({ id: this.$route.name })
  }
}
</script>

<style lang="scss" module>
.view {
  @extend %view-padding;
}

.list {
  display: flex;
  flex-wrap: wrap;

  > :first-child > * {
    padding-left: 0;
  }
}

.item {
  display: inline-block;
  // remove space introduced by inline-block, somehow only 0.35 would be necessary but it aligns only with 0.55em
  margin-bottom: calc(calc(var(--gutter) / 2) - 0.55em);

  &:not(:last-of-type) {
    margin-right: calc(calc(var(--gutter) / 2) - 0.25em);
  }

  @media (min-width: $small) {
    margin-bottom: calc(var(--gutter) - 0.55em);
  }
}

.year {
  display: inline-block;
  vertical-align: top;
  padding: 0 calc(var(--gutter) / 2) 0 calc(var(--gutter) * 2);
  // margin-right: calc(var(--gutter) * 2); // margin should collapse to 2em
  margin-top: -0.15em; // visually align with images

  @media (min-width: $medium) {
    padding: 0 calc(var(--gutter) / 2) 0 calc(var(--gutter) * 3);
  }
}

.image {
  height: 3.75em;
  display: inline-block;

  img {
    height: 100%;
    width: auto;
  }

  @media (min-width: $large) {
    height: 3em;
  }
}
</style>
